"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const t=e=>e&&e.replace(/\s+/," ").split(" ").slice(0,2).map(s=>s&&s[0].toUpperCase()).join("");exports.default=t;
